import React from 'react';

import { useDispatch } from 'react-redux';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import { Stack, Button, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import LogoutIcon from '@mui/icons-material/Logout';
import { useFullScreen } from '../../../../services/hooks';
import { setToken } from '../../../../services/redux-actions';
import { useManager } from '../../../../pages/Manager';
import { formatDate } from '../../../../services/functions';
import { LogoStaff } from '../../../../components/landing/LogoStaff';
import { Logo } from '../../../../components/landing/Logo';
import { logoutAction } from '../../../../services/request';
import { useMutation } from 'react-fetching-library';

const Header = () => {
  const { mutate } = useMutation(logoutAction);
  const isMobile = useMediaQuery('(max-width:600px)');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { applications, application, setApplication, tabsType, setTabsType } = useManager();
  const handleLogout = async () => {
    const { error } = await mutate();
    if (!error) {
      dispatch(setToken(null));
      navigate('/');
    }
  };

  const handleToggle = () => {
    if (tabsType == 'manager') {
      setTabsType('staff');
    } else {
      setTabsType('manager');
    }
  };

  return (
    <header>
      <Stack direction="row" justifyContent="space-between" alignItems={isMobile ? 'top' : 'center'}>
        {isMobile ? <LogoStaff /> : <Logo />}
        <div style={{ display: 'flex', flexDirection: isMobile ? 'column' : 'row', gap: '16px' }}>
          <Button variant="contained" endIcon={<LogoutIcon />} onClick={handleLogout}>wyloguj</Button>
          <Button variant="contained" onClick={handleToggle} color={tabsType == 'manager' ? 'primary' : 'secondary'}>
            {tabsType == 'manager' ? 'Zakładki kierownika' : 'Zakładki pracownika'}
          </Button>
          {application && <FormControl sx={{ minWidth: ' 160px' }}>
            <InputLabel variant="standard" htmlFor="uncontrolled-native">
              Wybierz aplikację
            </InputLabel>
            <Select
              placeholder="Wybierz aplikację"
              variant="standard"
              labelId="seasons"
              value={application.id}
              defaultValue={application.id}
              label="Sezony"
              onChange={e => setApplication(applications.filter(ap => ap.id === e.target.value)[0])}
              sx={{ maxWidth: isMobile ? 200 : 600 }}
            >
              {applications && applications.map(obj => (
                <MenuItem key={obj.id} value={obj.id}>{obj.function_type_display} {formatDate(obj.created_at)}</MenuItem>
              ))
              }
            </Select>
          </FormControl>}
        </div>
      </Stack>
    </header>
  );
};

export default Header;
